import React, { useState,useEffect } from "react";
import { Box, TextField,FormControl } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IntegrationSystemViewModel, IntegrationSettingsViewModel } from "../../../Types/ExportTypes";
import {
    LocationAutoComplete,
    ShopAutoComplete, CurrencyAutoComplete
} from "../../AutoComplete/AutoCompletes";
type ShopifyIntegrationProps = {
    viewModel: IntegrationSystemViewModel;
    setViewModel: React.Dispatch<React.SetStateAction<IntegrationSystemViewModel>>;
};


const ShopifyIntegration: React.FC<ShopifyIntegrationProps> = ({ viewModel, setViewModel }) => {
    const { t } = useTranslation();
    const [shopifyLocationId, setShopifyLocationId] = useState("");
    const [shopifyCurrency, setShopifyCurrency] = useState("");
    const [shopifyApiKey, setShopifyApiKey] = useState("");
    const [shopifyPassword, setShopifyPassword] = useState("");
    const [shopifyLocationCode, setShopifyLocationCode] = useState("");
    const [shopifyShopNo, setShopifyShopNo] = useState("");
    useEffect(() => {
        if (viewModel.tag !== "Shopify") {
            setViewModel(prev => ({ ...prev, tag: "Shopify", integrateItems: true, inventory: true, active: true,lockOrder : true, lockSalesLines : true  }));
        }
    }, [viewModel.tag, setViewModel]);


    const setSetting = (key: string, value: string) => {
        setViewModel(prev => {
            const settings = prev.settings ? [...prev.settings] : [];

            const idx = settings.findIndex(s => s.key === key);

            if (idx >= 0) {
                // update existing
                settings[idx] = { ...settings[idx], value };
            } else {
                // add new
                settings.push({
                    key,
                    value,
                    integrationId: prev.id ?? null,
                });
            }

            return { ...prev, settings };
        });
    };
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

            <TextField
                fullWidth
                label={t("common.description")}
                value={viewModel.description}
                onChange={(e) => setViewModel({ ...viewModel, description: e.target.value })}
                InputLabelProps={{ shrink: true }}
            />


            <TextField
                fullWidth
                label={"Url"}
                value={viewModel.serviceUrl1}
                onChange={(e) => setViewModel({ ...viewModel, serviceUrl1: e.target.value })}
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                label="Shopify Location Id (Int)"
                value={shopifyLocationId}
                onChange={(e) => {
                    const val = e.target.value;
                    setShopifyLocationId(val);
                    setSetting("ShopifyLocation", val);
                }}
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                label="Shopify Apikey"
                value={shopifyApiKey}
                onChange={(e) => {
                    const val = e.target.value;
                    setShopifyApiKey(val);
                    setSetting("Apikey", val);
                }}
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                label="Shopify Secret"
                value={shopifyPassword}
                onChange={(e) => {
                    const val = e.target.value;
                    setShopifyPassword(val);
                    setSetting("Password", val);
                }}
                InputLabelProps={{ shrink: true }}
            />


            <FormControl fullWidth margin="normal">
                <CurrencyAutoComplete
                    key={shopifyCurrency}
                    valueId={shopifyCurrency}
                    onChange={(selected) => {
                        const val = selected?.value ?? "";
                        setShopifyCurrency(val);
                        setSetting("ShopifyCurrency", val);
                    }}

                    infoText={t("help.currencyHelp")}
                />
            </FormControl>


            <FormControl fullWidth margin="normal">
                <ShopAutoComplete
                    key={shopifyShopNo}
                    valueId={shopifyShopNo}
                    onChange={(selected) => {
                        const val = selected?.value ?? "";
                        setShopifyShopNo(val);
                        setSetting("ShopNo", val);
                    }}

                    infoText={t("help.shopHelp")}
                />
            </FormControl>

            <FormControl fullWidth margin="normal">
                <LocationAutoComplete
                    key={shopifyLocationCode}
                    valueId={shopifyLocationCode}
                    onChange={(selected) => {
                        const val = selected?.value ?? "";
                        setShopifyLocationCode(val);
                        setSetting("LocationCode", val);
                    }}

                    infoText={t("help.locationHelp")}
                />
            </FormControl>


        </Box>
    );
};


export default ShopifyIntegration;
